import { Link, useParams } from "react-router-dom";
import { ArrowRight, Store } from "lucide-react";
import { useSeo } from "@/lib/seo";
import RESELLERS from "@/lib/resellers.json";
import { localZones } from "@/lib/localPages";
import { ResellerCard } from "@/components/resellers/ResellerCard";
import { Eyebrow } from "@/components/ambassadors/ui";
import NotFound from "@/pages/NotFound";

export const ZONES = localZones(RESELLERS);

function OtherZones({ current }) {
  return (
    <section data-testid="local-other-zones" className="mt-16">
      <h2 className="font-display text-2xl text-[#141013]">Ozentya ailleurs en France et outre-mer</h2>
      <ul className="mt-5 flex flex-wrap gap-2">
        {ZONES.filter((z) => z.slug !== current).map((z) => (
          <li key={z.slug}><Link to={z.path} data-testid={`local-zone-link-${z.slug}`} className="inline-block rounded-full border border-[#D9C8B3] bg-white px-4 py-2 text-xs font-semibold text-[#141013] transition-colors hover:border-[#7A5418]">{z.where} · {z.items.length}</Link></li>
        ))}
      </ul>
    </section>
  );
}

export default function LocalResellers() {
  const { zone } = useParams();
  const z = ZONES.find((x) => x.slug === zone);
  useSeo(z ? { title: z.title, description: z.description, path: z.path } : { title: "Page introuvable | Ozentya", noindex: true });
  if (!z) return <NotFound />;
  return (
    <main data-testid="local-resellers-page" className="bg-[#F6F0E7] px-5 pb-24 pt-32 md:px-10 md:pt-40">
      <div className="mx-auto max-w-6xl">
        <nav aria-label="Fil d'Ariane" className="mb-6 text-xs text-[#5E544D]"><Link to="/" className="hover:underline">Accueil</Link> / <Link to="/revendeurs" data-testid="local-crumb-resellers" className="hover:underline">Revendeurs</Link> / <span>{z.where}</span></nav>
        <Eyebrow>Points de vente · {z.where}</Eyebrow>
        <h1 data-testid="local-title" className="font-display text-4xl leading-[1.05] text-[#141013] sm:text-5xl lg:text-6xl">{z.h1}</h1>
        <p data-testid="local-intro" className="mt-6 max-w-3xl text-base leading-relaxed text-[#5E544D]">{z.intro}</p>
        {z.online ? <p className="mt-3 flex items-start gap-2 text-sm text-[#5E544D]"><Store className="mt-0.5 h-4 w-4 shrink-0 text-[#7A5418]" />{z.online}</p> : null}
        <ul data-testid="local-list" className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">{z.items.map((r) => <ResellerCard key={r.id} r={r} />)}</ul>
        <div className="mt-12 flex flex-col gap-3 rounded-3xl bg-[#141013] p-8 text-[#FBF8F3] md:flex-row md:items-center md:justify-between md:p-10">
          <p className="font-display text-2xl md:text-3xl">Pas le temps de passer en boutique ? <span className="italic text-[#E2C07E]">2 soins chaque mois pour 19,99 €.</span></p>
          <Link to="/abonnement?formule=duo" data-testid="local-duo-cta" className="inline-flex h-12 shrink-0 items-center justify-center gap-2 rounded-full bg-[#E2C07E] px-6 text-xs font-semibold uppercase tracking-[0.18em] text-[#141013] hover:bg-[#F1DBA6]">Découvrir le Duo <ArrowRight className="h-4 w-4" /></Link>
        </div>
        <OtherZones current={z.slug} />
      </div>
    </main>
  );
}
